<div class="d-flex flex-column">
	<div style="max-width: 1300px">
		<div
			class="d-flex my-3 flex-row justify-content-end align-items-end gap-2 position-relative">
			<label
				class="d-flex text-tertiary text-center fw-semibold position-absolute top-50 start-50 translate-middle">
				Climatologia (mm) -
				{{ periodo }}
			</label>
			<seira-select-list-menu
				[opcoes]="opcoesColunas"
				[opcoesSelecionadas]="colunasSelecionadas"
				[disabled]="disabledSelectList || loading"
				[tituloBotao]="'Personalizar colunas'"
				(atualizarOpcoesSelecionadas)="
					setColunasSelecionadas($event)
				"></seira-select-list-menu>
		</div>

		<div
			*ngIf="loading; else tabela"
			class="d-flex justify-content-center align-items-center w-100 h-50"
			style="min-height: 500px">
			<seira-loading [pageCentered]="false"></seira-loading>
		</div>

		<ng-template #tabela>
			<div
				style="max-width: 1300px"
				*ngIf="dadosTabelaClimatologia; else semDados">
				<div class="row mb-2">
					<seira-public-table
						#tabelaClimatologia
						id="tabela-climatologia"
						[hasFooter]="true"
						[hasHeader]="false"
						[info]="true"
						[paging]="true"
						[scrollX]="true"
						[searching]="false"
						[columns]="colunas"
						[data]="dadosTabelaClimatologia"></seira-public-table>
				</div>
			</div>
		</ng-template>
	</div>

	<ng-template #semDados>
		<seira-sem-dados />
	</ng-template>

	<seira-card-info [texto]="descricaoRelatorio" />
</div>
